"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function titleCase(s) {
    return s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
}
exports.default = titleCase;
